module.exports = __webpack_public_path__ + "img/Icon_PES_Title.2d494a0e.png";